/** Firebase の Web API キー（公開値。ブラウザの Firebase 設定とサーバーの本人確認で同じものを使う） */
export const FIREBASE_WEB_API_KEY =
  process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "AIzaSyAgyUdPToF8KoOURCDgOb1LiRJ6wo9NAYI";
